import { ToggleGroup, ToggleGroupItem } from '@/components/ui/toggle-group';
import { Globe } from 'lucide-react';
import type { WebsiteName } from '@/types/website';

interface WebsiteFilterProps {
  value: WebsiteName | 'all';
  onChange: (value: WebsiteName | 'all') => void;
}

export function WebsiteFilter({ value, onChange }: WebsiteFilterProps) {
  return (
    <ToggleGroup 
      type="single" 
      value={value} 
      onValueChange={(v) => v && onChange(v as WebsiteName | 'all')}
      className="bg-muted rounded-lg p-1"
    >
      <ToggleGroupItem value="all" className="text-xs px-3 data-[state=on]:bg-background">
        <Globe className="h-3.5 w-3.5 mr-1.5" />
        Alle
      </ToggleGroupItem>
      <ToggleGroupItem value="greenvision" className="text-xs px-3 data-[state=on]:bg-background">
        <span className="w-2 h-2 rounded-full bg-green-500 mr-1.5" />
        Greenvision
      </ToggleGroupItem>
      <ToggleGroupItem value="gv_charging" className="text-xs px-3 data-[state=on]:bg-background">
        <span className="w-2 h-2 rounded-full bg-blue-500 mr-1.5" />
        GV Charging
      </ToggleGroupItem>
    </ToggleGroup>
  );
}
